import ElasticProcessor from '@lib/processors/elastic-processor'
import store from '~/state/store.js'

const TABLE_FILTERS = [
  {
    attribute: 'createdAt',
    label: 'Date Created',
    icon: 'el-icon-date',
    type: 'date',
  },
  {
    attribute: 'updatedAt',
    label: 'Date Updated',
    icon: 'el-icon-date',
    type: 'date',
  },
  {
    attribute: 'name',
    label: 'Version Name',
    icon: 'el-icon-copy-document',
    type: 'string',
  },
  {
    attribute: 'active',
    label: 'Status',
    icon: 'el-icon-circle-check',
    type: 'select',
    values: [
      {
        value: true,
        label: 'Active',
      },
      {
        value: false,
        label: 'Inactive',
      },
    ],
  },
  {
    attribute: 'latest',
    label: 'Latest?',
    icon: 'el-icon-view',
    type: 'select',
    values: [
      {
        value: true,
        label: 'Yes',
      },
      {
        value: false,
        label: 'No',
      },
    ],
  },
]

const TABLE_COLUMNS = [
  {
    name: 'createdAt',
    label: 'Date Created',
    icon: 'el-icon-date',
    format: {
      name: 'date',
      params: ['DD/MM/YYYY'],
    },
    width: 200,
  },
  {
    name: 'updatedAt',
    label: 'Date Updated',
    icon: 'el-icon-date',
    format: {
      name: 'date',
      params: ['DD/MM/YYYY'],
    },
    width: 200,
  },
  {
    name: 'name',
    label: 'Version Name',
    icon: 'el-icon-copy-document',
    width: 200,
    elasticSubField: 'lowercase',
  },
  {
    name: 'active',
    label: 'Status',
    icon: 'el-icon-circle-check',
    width: 200,
    format: val => {
      if (val) {
        return 'Active'
      }

      return 'Inactive'
    },
    component: {
      props: {
        styleObj(_, row) {
          let color = '#e21d1f'

          if (row.active) {
            color = '#36d544'
          }

          return { color }
        },
        badge(_, row) {
          let name = 'el-icon-close'

          if (row.active) {
            name = 'el-icon-check'
          }

          return {
            name,
            pos: 'left',
          }
        },
      },
    },
  },
  {
    name: 'latest',
    label: 'Latest?',
    icon: 'el-icon-view',
    width: 200,
    format: val => {
      if (val) {
        return 'Yes'
      }

      return 'No'
    },
    component: {
      props: {
        allowEmpty: true,
        styleObj(_, row) {
          if (row.latest) {
            return { color: '#29d737' }
          }

          return { color: '#fc7168' }
        },
        badge(_, row) {
          if (row.latest) {
            return {
              name: 'el-icon-check',
              pos: 'left',
            }
          }

          return {
            name: 'el-icon-close',
            pos: 'left',
          }
        },
      },
    },
  },
]

export default component => ({
  processor: new ElasticProcessor({
    component,
    index: 'versions',
    headers: {
      'Provider-Id': store.getters['me/meProviderId'] || 'null',
    },
    staticDataQuery: {
      filters: [
        {
          attribute: 'productId',
          value: component.product.id,
        },
      ],
    },
    initialDataQuery: {
      defaultSort: {
        createdAt: 'desc',
      },
    },
  }),
  filters: TABLE_FILTERS,
  columns: TABLE_COLUMNS,
  tableName: 'versions',
})
